import { App, appMetadata, type CustomerFacingApp } from "@teamworksdev/react";
import type { TeamLinkedProduct } from "~/modules/TeamManagement/types";
import type { DocumentStatus } from "~/services/documents";
import { getAxleData } from "~/utils/axleDocuments";
import { sortingFns } from "~/utils/sorting";
import { StatusIndicator, type StatusVariant } from "./StatusIndicator";

const getStatusVariant = (status?: DocumentStatus): StatusVariant => {
  switch (status) {
    case "active":
      return "success";
    case "archive":
    case "inactive":
      return "error";
    default:
      return "disabled";
  }
};

type StatusGroupProps = {
  apps?: CustomerFacingApp[];
  linkedTeams: TeamLinkedProduct[];
};

export const StatusGroup = ({ apps = [], linkedTeams }: StatusGroupProps) => (
  <div className="flex gap-3 items-center">
    {Object.values(appMetadata)
      .filter((meta) => apps.includes(meta.appId))
      .sort(sortingFns.numeric((meta) => sortOrder[meta.appId] ?? 99))
      .map((metaData) => {
        const lt = linkedTeams.find((lt) => lt.app.slug === metaData.appId);
        const linkedTeamData = lt ? getAxleData(lt) : null;
        return (
          <StatusIndicator
            key={metaData.appId}
            teamName={linkedTeamData?.name}
            appName={metaData.name}
            variant={getStatusVariant(lt?.status)}
            appSlug={metaData.appId}
          />
        );
      })}
  </div>
);

const sortOrder: Partial<Record<CustomerFacingApp, number>> = {
  [App.hub]: 1,
  [App.camps]: 2,
  [App.displays]: 3,
  [App.arms]: 15,
  [App.inflcr]: 5,
  [App.collectives]: 6,
  [App.ams]: 7,
  [App.nutrition]: 8,
  [App.strength]: 9,
  [App.academics]: 10,
  [App.pathways]: 11,
  [App.pulse]: 12,
  [App.wallet]: 13,
};
